var vars = {
  state: {
    algos: [
      {
        code: 'xelishash',
        name: 'XelisHash',
        longName: 'XelisHashV2',
        typeCode: 'gpu',
        type: 'Graphic Card',
        new: true,
        tags: ['new'],
        miningVia: 'Graphic Cards',
        symbol: 'XEL',
        symbolLogo: 'https://unmineable.com/img/logos/XEL.png?v2',
        minimumVramRequirement: '3GB',
        unitOfMeasurement: 'h',
        preUnitOfMeasurement: '',
        minimumUnitOfMeasurement: 'h',
        minCalculatorUnit: 'k',
        maxCalculatorUnit: 'g',
        defaultCalculatorUnit: 'k',
        wizardSort: 11,
        extraComment: '',
        globalServer: {
          description: 'Global',
          url: 'xelishash.unmineable.com',
          urlCopy: 'stratum+ssl://xelishash.unmineable.com',
          sslPorts: ['4444', '443'],
          defaultPort: '4444',
          alternativePorts: ['3333', '13333', '80']
        },
        alternativeServers: [
          {
            country: 'usa',
            description: 'US',
            url: 'xelishash-us.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'england',
            description: 'EUROPE',
            url: 'xelishash-eu.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'singapore',
            description: 'ASIA',
            url: 'xelishash-asia.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          }
        ],
        showInWizard: true,
        guides: [
          {
            name: 'OneZeroMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-onezerominer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-onezerominer-for-gpu-mining/'
          },
          {
            name: 'SRBMiner',
            url: 'https://www.unmineable.com/support/article/how-to-setup-srbminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-srbminer-for-gpu-mining/'
          },
          {
            name: 'Rigel',
            url: 'https://unmineable.com/support/article/how-to-setup-rigel-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-rigel-for-gpu-mining/'
          }
        ],
        isInOurEasyMiningApp: false,
        xaxisCategoriesField: 'calculated',
        hasReportedHashrate: false,
        chartSeries: [
          { name: 'Speed', field: 'calculated' }
        ],
        chartOptions: {
          colors: ['#02ffcf'],
          stroke: {
            show: true,
            curve: 'smooth',
            width: 3
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 90, 100],
              shade: 'light'
            },
            opacity: [1, 0]
          },
          dataLabels: {
            enabled: false
          },
          chart: {
            foreColor: '#373d3f',
            type: 'area',
            zoom: {
              enabled: true
            },
            toolbar: {
              tools: {
                download: false,
                reset: '<i class="fa fa-arrow-right"></i>'
              },
              autoSelected: 'pan'
            }
          },
          xaxis: {
            labels: {
              offsetY: -2,
              datetimeUTC: false
            },
            categories: [],
            type: 'datetime',
            min: 0
          },
          yaxis: {
            labels: {
              show: false
            }
          },
          legend: {
            offsetY: 10,
            itemMargin: {
              vertical: 5
            }
          },
          grid: {
            yaxis: {
              lines: {
                show: false
              }
            },
            xaxis: {
              lines: {
                show: false
              }
            }
          },
          tooltip: {
            x: {
              format: 'yyyy-MM-dd HH:mm'
            }
          }
        }
      },
      {
        code: 'fishhash',
        name: 'FishHash',
        longName: 'FishHash',
        typeCode: 'gpu',
        type: 'Graphic Card',
        new: true,
        tags: ['new'],
        miningVia: 'Graphic Cards',
        symbol: 'IRON',
        symbolLogo: 'https://unmineable.com/img/logos/IRON.png',
        minimumVramRequirement: '6GB',
        unitOfMeasurement: 'h',
        preUnitOfMeasurement: '',
        minimumUnitOfMeasurement: 'h',
        minCalculatorUnit: 'm',
        maxCalculatorUnit: 'g',
        defaultCalculatorUnit: 'm',
        wizardSort: 11,
        extraComment: '',
        globalServer: {
          description: 'Global',
          url: 'fishhash.unmineable.com',
          urlCopy: 'stratum+ssl://fishhash.unmineable.com',
          sslPorts: ['4444', '443'],
          defaultPort: '4444',
          alternativePorts: ['3333', '13333', '80']
        },
        alternativeServers: [
          {
            country: 'usa',
            description: 'US',
            url: 'fishhash-us.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'england',
            description: 'EUROPE',
            url: 'fishhash-eu.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'singapore',
            description: 'ASIA',
            url: 'fishhash-asia.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          }
        ],
        showInWizard: true,
        guides: [
          {
            name: 'lolMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-lolminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-lolminer-for-gpu-mining/'
          },
          {
            name: 'SRBMiner',
            url: 'https://www.unmineable.com/support/article/how-to-setup-srbminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-srbminer-for-gpu-mining/'
          },
          {
            name: 'Rigel',
            url: 'https://unmineable.com/support/article/how-to-setup-rigel-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-rigel-for-gpu-mining/'
          }
        ],
        isInOurEasyMiningApp: true,
        xaxisCategoriesField: 'calculated',
        hasReportedHashrate: false,
        chartSeries: [
          { name: 'Speed', field: 'calculated' }
        ],
        chartOptions: {
          colors: ['#C7F182'],
          stroke: {
            show: true,
            curve: 'smooth',
            width: 3
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 90, 100],
              shade: 'light'
            },
            opacity: [1, 0]
          },
          dataLabels: {
            enabled: false
          },
          chart: {
            foreColor: '#373d3f',
            type: 'area',
            zoom: {
              enabled: true
            },
            toolbar: {
              tools: {
                download: false,
                reset: '<i class="fa fa-arrow-right"></i>'
              },
              autoSelected: 'pan'
            }
          },
          xaxis: {
            labels: {
              offsetY: -2,
              datetimeUTC: false
            },
            categories: [],
            type: 'datetime',
            min: 0
          },
          yaxis: {
            labels: {
              show: false
            }
          },
          legend: {
            offsetY: 10,
            itemMargin: {
              vertical: 5
            }
          },
          grid: {
            yaxis: {
              lines: {
                show: false
              }
            },
            xaxis: {
              lines: {
                show: false
              }
            }
          },
          tooltip: {
            x: {
              format: 'yyyy-MM-dd HH:mm'
            }
          }
        }
      },
      {
        code: 'blake3',
        name: 'Blake3',
        longName: 'Blake3 (Alephium)',
        typeCode: 'gpu',
        type: 'Graphic Card',
        new: false,
        miningVia: 'Graphic Cards',
        symbol: 'ALPH',
        symbolLogo: 'https://unmineable.com/img/logos/ALPH.png',
        minimumVramRequirement: '4GB',
        unitOfMeasurement: 'h',
        preUnitOfMeasurement: '',
        minimumUnitOfMeasurement: 'h',
        minCalculatorUnit: 'm',
        maxCalculatorUnit: 'g',
        defaultCalculatorUnit: 'm',
        wizardSort: 10,
        extraComment: '',
        globalServer: {
          description: 'Global',
          url: 'blake3.unmineable.com',
          urlCopy: 'stratum+ssl://blake3.unmineable.com',
          sslPorts: ['4444', '443'],
          defaultPort: '4444',
          alternativePorts: ['3333', '13333', '80']
        },
        alternativeServers: [
          {
            country: 'usa',
            description: 'US',
            url: 'blake3-us.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'england',
            description: 'EUROPE',
            url: 'blake3-eu.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'singapore',
            description: 'ASIA',
            url: 'blake3-asia.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          }
        ],
        showInWizard: true,
        guides: [
          {
            name: 'lolMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-lolminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-lolminer-for-gpu-mining/'
          },
          {
            name: 'T-Rex',
            url: 'https://unmineable.com/support/article/how-to-setup-t-rex-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-t-rex-for-gpu-mining/'
          },
          {
            name: 'SRBMiner',
            url: 'https://www.unmineable.com/support/article/how-to-setup-srbminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-srbminer-for-gpu-mining/'
          },
          {
            name: 'BzMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-bzminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-bzminer-for-gpu-mining/'
          },
          {
            name: 'Rigel',
            url: 'https://unmineable.com/support/article/how-to-setup-rigel-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-rigel-for-gpu-mining/'
          }
        ],
        isInOurEasyMiningApp: true,
        xaxisCategoriesField: 'calculated',
        hasReportedHashrate: false,
        chartSeries: [
          { name: 'Speed', field: 'calculated' }
        ],
        chartOptions: {
          colors: ['#ff5d51'],
          stroke: {
            show: true,
            curve: 'smooth',
            width: 3
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 90, 100],
              shade: 'light'
            },
            opacity: [1, 0]
          },
          dataLabels: {
            enabled: false
          },
          chart: {
            foreColor: '#373d3f',
            type: 'area',
            zoom: {
              enabled: true
            },
            toolbar: {
              tools: {
                download: false,
                reset: '<i class="fa fa-arrow-right"></i>'
              },
              autoSelected: 'pan'
            }
          },
          xaxis: {
            labels: {
              offsetY: -2,
              datetimeUTC: false
            },
            categories: [],
            type: 'datetime',
            min: 0
          },
          yaxis: {
            labels: {
              show: false
            }
          },
          legend: {
            offsetY: 10,
            itemMargin: {
              vertical: 5
            }
          },
          grid: {
            yaxis: {
              lines: {
                show: false
              }
            },
            xaxis: {
              lines: {
                show: false
              }
            }
          },
          tooltip: {
            x: {
              format: 'yyyy-MM-dd HH:mm'
            }
          }
        }
      },
      {
        code: 'randomx',
        name: 'RandomX',
        typeCode: 'cpu',
        type: 'CPU',
        miningVia: 'CPUs',
        symbol: 'XMR',
        symbolLogo: 'https://unmineable.com/img/logos/XMR.png',
        minimumVramRequirement: null,
        unitOfMeasurement: 'h',
        preUnitOfMeasurement: '',
        minimumUnitOfMeasurement: 'h',
        minCalculatorUnit: '',
        maxCalculatorUnit: 'm',
        wizardSort: 1,
        customStaticDiff: true,
        globalServer: {
          description: 'Global',
          url: 'rx.unmineable.com',
          urlCopy: 'stratum+ssl://rx.unmineable.com',
          sslPorts: ['443'],
          defaultPort: '443',
          alternativePorts: ['3333', '13333', '80'],
          extraPorts: [
            {
              name: 'Compatible with xmr-node-proxy',
              showType: true,
              ports: [
                { number: '4445' },
                { ssl: true, number: '14445' }
              ]
            }
          ]
        },
        alternativeServers: [
          {
            country: 'usa',
            description: 'US',
            url: 'rx-us.unmineable.com',
            sslPorts: ['443'],
            defaultPort: '443',
            alternativePorts: ['3333', '13333', '80'],
            extraPorts: [
              {
                name: 'Compatible with xmr-node-proxy',
                showType: true,
                ports: [
                  { number: '4445' },
                  { ssl: true, number: '14445' }
                ]
              }
            ]
          },
          {
            country: 'england',
            description: 'EUROPE',
            url: 'rx-eu.unmineable.com',
            sslPorts: ['443'],
            defaultPort: '443',
            alternativePorts: ['3333', '13333', '80'],
            extraPorts: [
              {
                name: 'Compatible with xmr-node-proxy',
                showType: true,
                ports: [
                  { number: '4445' },
                  { ssl: true, number: '14445' }
                ]
              }
            ]
          },
          {
            country: 'singapore',
            description: 'ASIA',
            url: 'rx-asia.unmineable.com',
            sslPorts: ['443'],
            defaultPort: '443',
            alternativePorts: ['3333', '13333', '80'],
            extraPorts: [
              {
                name: 'Compatible with xmr-node-proxy',
                showType: true,
                ports: [
                  { number: '4445' },
                  { ssl: true, number: '14445' }
                ]
              }
            ]
          }
        ],
        showInWizard: true,
        guides: [
          {
            name: 'Xmrig',
            url: 'https://unmineable.com/support/article/how-to-setup-xmrig-for-cpu-mining/',
            relativeUrl: '/support/article/how-to-setup-xmrig-for-cpu-mining/'
          },
          {
            name: 'SRBMiner',
            url: 'https://www.unmineable.com/support/article/how-to-setup-srbminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-srbminer-for-gpu-mining/'
          }
        ],
        isInOurEasyMiningApp: true,
        xaxisCategoriesField: 'calculated',
        measure: 'h',
        hasReportedHashrate: false,
        chartSeries: [
          { name: 'Speed', field: 'calculated' }
        ],
        chartOptions: {
          colors: ['#ff3860', '#ff96ab'],
          stroke: {
            show: true,
            curve: 'smooth',
            width: [3, 2]
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 90, 100],
              shade: 'light'
            }
          },
          dataLabels: {
            enabled: false
          },
          chart: {
            foreColor: '#373d3f',
            type: 'area',
            zoom: {
              enabled: true
            },
            toolbar: {
              tools: {
                download: false,
                reset: '<i class="fa fa-arrow-right"></i>'
              },
              autoSelected: 'pan'
            }
          },
          xaxis: {
            labels: {
              offsetY: -2,
              datetimeUTC: false
            },
            categories: [],
            type: 'datetime',
            min: 0
          },
          yaxis: {
            labels: {
              show: false
            }
          },
          legend: {
            offsetY: -10
          },
          grid: {
            yaxis: {
              lines: {
                show: false
              }
            },
            xaxis: {
              lines: {
                show: false
              }
            }
          },
          tooltip: {
            x: {
              format: 'yyyy-MM-dd HH:mm'
            }
          }
        }
      },
      {
        code: 'ghostrider',
        name: 'GhostRider',
        typeCode: 'cpu',
        type: 'CPU',
        miningVia: 'CPUs',
        new: true,
        tags: ['new'],
        symbol: 'RTM',
        symbolLogo: 'https://unmineable.com/img/logos/RTM.png?v2',
        minimumVramRequirement: null,
        unitOfMeasurement: 'h',
        preUnitOfMeasurement: '',
        minimumUnitOfMeasurement: 'h',
        minCalculatorUnit: '',
        maxCalculatorUnit: 'm',
        wizardSort: 1,
        globalServer: {
          description: 'Global',
          url: 'ghostrider.unmineable.com',
          urlCopy: 'stratum+ssl://ghostrider.unmineable.com',
          sslPorts: ['443'],
          defaultPort: '443',
          alternativePorts: ['3333', '13333', '80']
        },
        alternativeServers: [
          {
            country: 'usa',
            description: 'US',
            url: 'ghostrider-us.unmineable.com',
            sslPorts: ['443'],
            defaultPort: '443',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'england',
            description: 'EUROPE',
            url: 'ghostrider-eu.unmineable.com',
            sslPorts: ['443'],
            defaultPort: '443',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'singapore',
            description: 'ASIA',
            url: 'ghostrider-asia.unmineable.com',
            sslPorts: ['443'],
            defaultPort: '443',
            alternativePorts: ['3333', '13333', '80']
          }
        ],
        showInWizard: true,
        guides: [
          {
            name: 'Xmrig',
            url: 'https://unmineable.com/support/article/how-to-setup-xmrig-for-cpu-mining/',
            relativeUrl: '/support/article/how-to-setup-xmrig-for-cpu-mining/'
          },
          {
            name: 'SRBMiner',
            url: 'https://www.unmineable.com/support/article/how-to-setup-srbminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-srbminer-for-gpu-mining/'
          }
        ],
        isInOurEasyMiningApp: false,
        xaxisCategoriesField: 'calculated',
        measure: 'h',
        hasReportedHashrate: false,
        chartSeries: [
          { name: 'Speed', field: 'calculated' }
        ],
        chartOptions: {
          colors: ['#b64224', '#77220C'],
          stroke: {
            show: true,
            curve: 'smooth',
            width: [3, 2]
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 90, 100],
              shade: 'light'
            }
          },
          dataLabels: {
            enabled: false
          },
          chart: {
            foreColor: '#373d3f',
            type: 'area',
            zoom: {
              enabled: true
            },
            toolbar: {
              tools: {
                download: false,
                reset: '<i class="fa fa-arrow-right"></i>'
              },
              autoSelected: 'pan'
            }
          },
          xaxis: {
            labels: {
              offsetY: -2,
              datetimeUTC: false
            },
            categories: [],
            type: 'datetime',
            min: 0
          },
          yaxis: {
            labels: {
              show: false
            }
          },
          legend: {
            offsetY: -10
          },
          grid: {
            yaxis: {
              lines: {
                show: false
              }
            },
            xaxis: {
              lines: {
                show: false
              }
            }
          },
          tooltip: {
            x: {
              format: 'yyyy-MM-dd HH:mm'
            }
          }
        }
      },
      {
        code: 'karlsenhash',
        name: 'KarlsenHash',
        longName: 'KarlsenHashV2',
        typeCode: 'gpu',
        type: 'Graphic Card',
        miningVia: 'Graphic Cards',
        symbol: 'KLS',
        symbolLogo: 'https://unmineable.com/img/logos/KLS.png',
        tags: ['kasforks'],
        minimumVramRequirement: '3GB',
        unitOfMeasurement: 'h',
        preUnitOfMeasurement: '',
        minimumUnitOfMeasurement: 'h',
        minCalculatorUnit: 'm',
        maxCalculatorUnit: 't',
        defaultCalculatorUnit: 'm',
        wizardSort: 14,
        extraComment: '',
        globalServer: {
          description: 'Global',
          url: 'karlsenhash.unmineable.com',
          urlCopy: 'stratum+ssl://karlsenhash.unmineable.com',
          sslPorts: ['4444', '443'],
          defaultPort: '4444',
          alternativePorts: ['3333', '13333', '80']
        },
        alternativeServers: [
          {
            country: 'usa',
            description: 'US',
            url: 'karlsenhash-us.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'england',
            description: 'EUROPE',
            url: 'karlsenhash-eu.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'singapore',
            description: 'ASIA',
            url: 'karlsenhash-asia.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          }
        ],
        showInWizard: true,
        guides: [
          {
            name: 'lolMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-lolminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-lolminer-for-gpu-mining/'
          },
          {
            name: 'Rigel',
            url: 'https://unmineable.com/support/article/how-to-setup-rigel-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-rigel-for-gpu-mining/'
          },
          {
            name: 'SRBMiner',
            url: 'https://www.unmineable.com/support/article/how-to-setup-srbminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-srbminer-for-gpu-mining/'
          }
        ],
        isInOurEasyMiningApp: true,
        xaxisCategoriesField: 'calculated',
        hasReportedHashrate: false,
        chartSeries: [
          { name: 'Speed', field: 'calculated' }
        ],
        chartOptions: {
          colors: ['#3e6c97'],
          stroke: {
            show: true,
            curve: 'smooth',
            width: 3
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 90, 100],
              shade: 'light'
            },
            opacity: [1, 0]
          },
          dataLabels: {
            enabled: false
          },
          chart: {
            foreColor: '#373d3f',
            type: 'area',
            zoom: {
              enabled: true
            },
            toolbar: {
              tools: {
                download: false,
                reset: '<i class="fa fa-arrow-right"></i>'
              },
              autoSelected: 'pan'
            }
          },
          xaxis: {
            labels: {
              offsetY: -2,
              datetimeUTC: false
            },
            categories: [],
            type: 'datetime',
            min: 0
          },
          yaxis: {
            labels: {
              show: false
            }
          },
          legend: {
            offsetY: 10,
            itemMargin: {
              vertical: 5
            }
          },
          grid: {
            yaxis: {
              lines: {
                show: false
              }
            },
            xaxis: {
              lines: {
                show: false
              }
            }
          },
          tooltip: {
            x: {
              format: 'yyyy-MM-dd HH:mm'
            }
          }
        }
      },
      {
        code: 'nexapow',
        name: 'Nexapow',
        longName: 'Nexapow',
        typeCode: 'gpu',
        type: 'Graphic Card',
        new: false,
        miningVia: 'Graphic Cards',
        symbol: 'NEXA',
        symbolLogo: 'https://unmineable.com/img/logos/NEXA.png',
        minimumVramRequirement: '4GB',
        unitOfMeasurement: 'h',
        preUnitOfMeasurement: '',
        minimumUnitOfMeasurement: 'h',
        minCalculatorUnit: 'm',
        maxCalculatorUnit: 'g',
        defaultCalculatorUnit: 'm',
        wizardSort: 13,
        extraComment: '',
        globalServer: {
          description: 'Global',
          url: 'nexapow.unmineable.com',
          urlCopy: 'stratum+ssl://nexapow.unmineable.com',
          sslPorts: ['4444', '443'],
          defaultPort: '4444',
          alternativePorts: ['3333', '13333', '80']
        },
        alternativeServers: [
          {
            country : 'usa',
            description: 'US',
            url: 'nexapow-us.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'england',
            description: 'EUROPE',
            url: 'nexapow-eu.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'singapore',
            description: 'ASIA',
            url: 'nexapow-asia.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          }
        ],
        showInWizard: true,
        guides: [
          {
            name: 'lolMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-lolminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-lolminer-for-gpu-mining/'
          },
          {
            name: 'BzMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-bzminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-bzminer-for-gpu-mining/'
          },
          {
            name: 'Rigel',
            url: 'https://unmineable.com/support/article/how-to-setup-rigel-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-rigel-for-gpu-mining/'
          }
        ],
        isInOurEasyMiningApp: true,
        xaxisCategoriesField: 'calculated',
        hasReportedHashrate: false,
        chartSeries: [
          { name: 'Speed', field: 'calculated' }
        ],
        chartOptions: {
          colors: ['#FFE144'],
          stroke: {
            show: true,
            curve: 'smooth',
            width: 3
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 90, 100],
              shade: 'light'
            },
            opacity: [1, 0]
          },
          dataLabels: {
            enabled: false
          },
          chart: {
            foreColor: '#373d3f',
            type: 'area',
            zoom: {
              enabled: true
            },
            toolbar: {
              tools: {
                download: false,
                reset: '<i class="fa fa-arrow-right"></i>'
              },
              autoSelected: 'pan'
            }
          },
          xaxis: {
            labels: {
              offsetY: -2,
              datetimeUTC: false
            },
            categories: [],
            type: 'datetime',
            min: 0
          },
          yaxis: {
            labels: {
              show: false
            }
          },
          legend: {
            offsetY: 10,
            itemMargin: {
              vertical: 5
            }
          },
          grid: {
            yaxis: {
              lines: {
                show: false
              }
            },
            xaxis: {
              lines: {
                show: false
              }
            }
          },
          tooltip: {
            x: {
              format: 'yyyy-MM-dd HH:mm'
            }
          }
        }
      },
      {
        code: 'octopus',
        name: 'Octopus',
        longName: 'Octopus',
        typeCode: 'gpu',
        type: 'Graphic Card',
        new: false,
        miningVia: 'Graphic Cards',
        symbol: 'CFX',
        symbolLogo: 'https://unmineable.com/img/logos/CFX.png',
        minimumVramRequirement: '6GB',
        unitOfMeasurement: 'h',
        preUnitOfMeasurement: '',
        minimumUnitOfMeasurement: 'h',
        minCalculatorUnit: 'm',
        maxCalculatorUnit: 'g',
        defaultCalculatorUnit: 'm',
        wizardSort: 12,
        extraComment: '',
        globalServer: {
          description: 'Global',
          url: 'octopus.unmineable.com',
          urlCopy: 'stratum+ssl://octopus.unmineable.com',
          sslPorts: ['4444', '443'],
          defaultPort: '4444',
          alternativePorts: ['3333', '13333', '80']
        },
        alternativeServers: [
          {
            country : 'usa',
            description: 'US',
            url: 'octopus-us.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'england',
            description: 'EUROPE',
            url: 'octopus-eu.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'singapore',
            description: 'ASIA',
            url: 'octopus-asia.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          }
        ],
        showInWizard: true,
        guides: [
          {
            name: 'NBMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-nbminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-nbminer-for-gpu-mining/'
          },
          {
            name: 'T-Rex',
            url: 'https://unmineable.com/support/article/how-to-setup-t-rex-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-t-rex-for-gpu-mining/'
          },
          {
            name: 'GMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-gminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-gminer-for-gpu-mining/'
          },
          {
            name: 'BMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-bminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-bminer-for-gpu-mining/'
          }
        ],
        isInOurEasyMiningApp: true,
        xaxisCategoriesField: 'calculated',
        hasReportedHashrate: false,
        chartSeries: [
          { name: 'Speed', field: 'calculated' }
        ],
        chartOptions: {
          colors: ['#38A1DB'],
          stroke: {
            show: true,
            curve: 'smooth',
            width: 3
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 90, 100],
              shade: 'light'
            },
            opacity: [1, 0]
          },
          dataLabels: {
            enabled: false
          },
          chart: {
            foreColor: '#373d3f',
            type: 'area',
            zoom: {
              enabled: true
            },
            toolbar: {
              tools: {
                download: false,
                reset: '<i class="fa fa-arrow-right"></i>'
              },
              autoSelected: 'pan'
            }
          },
          xaxis: {
            labels: {
              offsetY: -2,
              datetimeUTC: false
            },
            categories: [],
            type: 'datetime',
            min: 0
          },
          yaxis: {
            labels: {
              show: false
            }
          },
          legend: {
            offsetY: 10,
            itemMargin: {
              vertical: 5
            }
          },
          grid: {
            yaxis: {
              lines: {
                show: false
              }
            },
            xaxis: {
              lines: {
                show: false
              }
            }
          },
          tooltip: {
            x: {
              format: 'yyyy-MM-dd HH:mm'
            }
          }
        }
      },
      {
        code: 'kheavyhash',
        name: 'KHeavyHash',
        longName: 'KHeavyHash',
        typeCode: 'gpu',
        type: 'Graphic Card',
        additionalTypes: ['asic'],
        additionalTypesDescription: 'Graphic Cards & ASIC',
        new: false,
        tags: ['kasforks'],
        miningVia: 'Graphic Cards & ASICs',
        symbol: 'KAS',
        symbolLogo: 'https://unmineable.com/img/logos/KAS.png',
        minimumVramRequirement: '3GB',
        unitOfMeasurement: 'h',
        preUnitOfMeasurement: '',
        minimumUnitOfMeasurement: 'h',
        minCalculatorUnit: 'm',
        maxCalculatorUnit: 't',
        defaultCalculatorUnit: 'm',
        wizardSort: 9,
        extraComment: '',
        customStaticDiff: true,
        globalServer: {
          description: 'Global',
          url: 'kheavyhash.unmineable.com',
          urlCopy: 'stratum+ssl://kheavyhash.unmineable.com',
          sslPorts: ['4444', '443'],
          defaultPort: '4444',
          alternativePorts: ['3333', '13333', '80'],
          extraPorts: [
            {
              name: 'GPU SSL Ports',
              ports: [
                { ssl: true, number: '4444' },
                { ssl: true, number: '443' }
              ]
            },
            {
              name: 'GPU TCP Ports',
              ports: [
                { number: '3333' },
                { number: '13333' },
                { number: '80' }
              ]
            },
            {
              name: 'Iceriver KS0 / KS0 Pro / KS0 Ultra',
              showType: true,
              ports: [
                { number: '4445' },
                { ssl: true, number: '14445' }
              ]
            },
            {
              name: 'Iceriver KS1 / KS2, Goldshell KA BOX',
              showType: true,
              ports: [
                { number: '4446' },
                { ssl: true, number: '14446' }
              ]
            },
            {
              name: 'IceRiver KS3L / KS3M',
              showType: true,
              ports: [
                { number: '4447' },
                { ssl: true, number: '14447' }
              ]
            },
            {
              name: 'IceRiver KS3, Bitmain KS3 / KS5, iBeLink BM-KSMax, TheWindMiner K9',
              showType: true,
              ports: [
                { number: '4448' },
                { ssl: true, number: '14448' }
              ]
            }
          ]
        },
        alternativeServers: [
          {
            country : 'usa',
            description: 'US',
            url: 'kheavyhash-us.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80'],
            extraPorts: [
              {
                name: 'GPU SSL Ports',
                ports: [
                  { ssl: true, number: '4444' },
                  { ssl: true, number: '443' }
                ]
              },
              {
                name: 'GPU TCP Ports',
                ports: [
                  { number: '3333' },
                  { number: '13333' },
                  { number: '80' }
                ]
              },
              {
                name: 'KS0 & NiceHash',
                showType: true,
                ports: [
                  { number: '4445' },
                  { ssl: true, number: '14445' }
                ]
              },
              {
                name: 'KS1 & KS2',
                showType: true,
                ports: [
                  { number: '4446' },
                  { ssl: true, number: '14446' }
                ]
              },
              {
                name: 'KS3 & KS3L',
                showType: true,
                ports: [
                  { number: '4447' },
                  { ssl: true, number: '14447' }
                ]
              }
            ]
          },
          {
            country: 'england',
            description: 'EUROPE',
            url: 'kheavyhash-eu.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80'],
            extraPorts: [
              {
                name: 'GPU SSL Ports',
                ports: [
                  { ssl: true, number: '4444' },
                  { ssl: true, number: '443' }
                ]
              },
              {
                name: 'GPU TCP Ports',
                ports: [
                  { number: '3333' },
                  { number: '13333' },
                  { number: '80' }
                ]
              },
              {
                name: 'KS0 & NiceHash',
                showType: true,
                ports: [
                  { number: '4445' },
                  { ssl: true, number: '14445' }
                ]
              },
              {
                name: 'KS1 & KS2',
                showType: true,
                ports: [
                  { number: '4446' },
                  { ssl: true, number: '14446' }
                ]
              },
              {
                name: 'KS3 & KS3L',
                showType: true,
                ports: [
                  { number: '4447' },
                  { ssl: true, number: '14447' }
                ]
              }
            ]
          },
          {
            country: 'singapore',
            description: 'ASIA',
            url: 'kheavyhash-asia.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80'],
            extraPorts: [
              {
                name: 'GPU SSL Ports',
                ports: [
                  { ssl: true, number: '4444' },
                  { ssl: true, number: '443' }
                ]
              },
              {
                name: 'GPU TCP Ports',
                ports: [
                  { number: '3333' },
                  { number: '13333' },
                  { number: '80' }
                ]
              },
              {
                name: 'KS0 & NiceHash',
                showType: true,
                ports: [
                  { number: '4445' },
                  { ssl: true, number: '14445' }
                ]
              },
              {
                name: 'KS1 & KS2',
                showType: true,
                ports: [
                  { number: '4446' },
                  { ssl: true, number: '14446' }
                ]
              },
              {
                name: 'KS3 & KS3L',
                showType: true,
                ports: [
                  { number: '4447' },
                  { ssl: true, number: '14447' }
                ]
              }
            ]
          }
        ],
        showInWizard: true,
        guides: [
          {
            name: 'lolMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-lolminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-lolminer-for-gpu-mining/'
          },
          {
            name: 'SRBMiner',
            url: 'https://www.unmineable.com/support/article/how-to-setup-srbminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-srbminer-for-gpu-mining/'
          },
          {
            name: 'BzMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-bzminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-bzminer-for-gpu-mining/'
          },
          {
            name: 'Rigel',
            url: 'https://unmineable.com/support/article/how-to-setup-rigel-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-rigel-for-gpu-mining/'
          },
          {
            name: 'Antminer',
            url: 'https://unmineable.com/support/article/how-to-setup-antminer-for-asic-mining/',
            relativeUrl: '/support/article/how-to-setup-antminer-for-asic-mining/'
          }
        ],
        isInOurEasyMiningApp: true,
        xaxisCategoriesField: 'calculated',
        hasReportedHashrate: false,
        chartSeries: [
          { name: 'Speed', field: 'calculated' }
        ],
        chartOptions: {
          colors: ['#70C9BB'],
          stroke: {
            show: true,
            curve: 'smooth',
            width: 3
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 90, 100],
              shade: 'light'
            },
            opacity: [1, 0]
          },
          dataLabels: {
            enabled: false
          },
          chart: {
            foreColor: '#373d3f',
            type: 'area',
            zoom: {
              enabled: true
            },
            toolbar: {
              tools: {
                download: false,
                reset: '<i class="fa fa-arrow-right"></i>'
              },
              autoSelected: 'pan'
            }
          },
          xaxis: {
            labels: {
              offsetY: -2,
              datetimeUTC: false
            },
            categories: [],
            type: 'datetime',
            min: 0
          },
          yaxis: {
            labels: {
              show: false
            }
          },
          legend: {
            offsetY: 10,
            itemMargin: {
              vertical: 5
            }
          },
          grid: {
            yaxis: {
              lines: {
                show: false
              }
            },
            xaxis: {
              lines: {
                show: false
              }
            }
          },
          tooltip: {
            x: {
              format: 'yyyy-MM-dd HH:mm'
            }
          }
        }
      },
      {
        code: 'equihash',
        name: 'Equihash',
        typeCode: 'asic',
        type: 'ASIC',
        new: false,
        miningVia: 'ASICs',
        symbol: 'ZEC',
        symbolLogo: 'https://unmineable.com/img/logos/ZEC.png',
        minimumVramRequirement: null,
        unitOfMeasurement: 'sol',
        preUnitOfMeasurement: '',
        minimumUnitOfMeasurement: 'sol',
        minCalculatorUnit: 'k',
        maxCalculatorUnit: 'g',
        defaultCalculatorUnit: 'k',
        wizardSort: 7,
        globalServer: {
          description: 'Global',
          url: 'equihash.unmineable.com',
          urlCopy: 'stratum+ssl://equihash.unmineable.com',
          sslPorts: ['4444', '443'],
          defaultPort: '4444',
          alternativePorts: ['3333', '13333', '80'],
          highDiffPorts: [
            {
              port: '4445',
              ssl: false
            },
            {
              port: '4446',
              ssl: true
            }
          ]
        },
        alternativeServers: [
          {
            country : 'usa',
            description: 'US',
            url: 'equihash-us.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80'],
            highDiffPorts: [
              {
                port: '4445',
                ssl: false
              },
              {
                port: '4446',
                ssl: true
              }
            ]
          },
          {
            country: 'england',
            description: 'EUROPE',
            url: 'equihash-eu.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80'],
            highDiffPorts: [
              {
                port: '4445',
                ssl: false
              },
              {
                port: '4446',
                ssl: true
              }
            ]
          },
          {
            country: 'singapore',
            description: 'ASIA',
            url: 'equihash-asia.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80'],
            highDiffPorts: [
              {
                port: '4445',
                ssl: false
              },
              {
                port: '4446',
                ssl: true
              }
            ]
          }
        ],
        showInWizard: false,
        guides: [
          {
            name: 'Antminer',
            url: 'https://unmineable.com/support/article/how-to-setup-antminer-for-asic-mining/',
            relativeUrl: '/support/article/how-to-setup-antminer-for-asic-mining/'
          },
          {
            name: 'Innosilicon',
            url: 'https://unmineable.com/support/article/how-to-setup-innosilicon-for-asic-mining/',
            relativeUrl: '/support/article/how-to-setup-innosilicon-for-asic-mining/'
          }
        ],
        xaxisCategoriesField: 'calculated',
        hasReportedHashrate: false,
        chartSeries: [
          { name: 'Speed', field: 'calculated' }
        ],
        chartOptions: {
          colors: ['#F4B827'],
          stroke: {
            show: true,
            curve: 'smooth',
            width: 3
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 90, 100],
              shade: 'light'
            },
            opacity: [1, 0]
          },
          dataLabels: {
            enabled: false
          },
          chart: {
            foreColor: '#373d3f',
            type: 'area',
            zoom: {
              enabled: true
            },
            toolbar: {
              tools: {
                download: false,
                reset: '<i class="fa fa-arrow-right"></i>'
              },
              autoSelected: 'pan'
            }
          },
          xaxis: {
            labels: {
              offsetY: -2,
              datetimeUTC: false
            },
            categories: [],
            type: 'datetime',
            min: 0
          },
          yaxis: {
            labels: {
              show: false
            }
          },
          legend: {
            offsetY: 10,
            itemMargin: {
              vertical: 5
            }
          },
          grid: {
            yaxis: {
              lines: {
                show: false
              }
            },
            xaxis: {
              lines: {
                show: false
              }
            }
          },
          tooltip: {
            x: {
              format: 'yyyy-MM-dd HH:mm'
            }
          }
        }
      },
      {
        code: 'sha256',
        name: 'SHA-256',
        longName: 'SHA256d',
        typeCode: 'asic',
        type: 'ASIC',
        new: false,
        miningVia: 'ASICs',
        symbol: 'BTC',
        symbolLogo: 'https://unmineable.com/img/logos/BTC.png',
        minimumVramRequirement: null,
        unitOfMeasurement: 'gh',
        preUnitOfMeasurement: 'g',
        minimumUnitOfMeasurement: 'h',
        minCalculatorUnit: 'g',
        maxCalculatorUnit: 'p',
        defaultCalculatorUnit: 't',
        wizardSort: 7,
        globalServer: {
          description: 'Global',
          url: 'sha256.unmineable.com',
          urlCopy: 'stratum+ssl://sha256.unmineable.com',
          sslPorts: ['4444', '443'],
          defaultPort: '4444',
          alternativePorts: ['3333', '13333', '80'],
          extraPorts: [
            {
              name: 'Low difficulty (10+)',
              showType: true,
              ports: [
                { number: '5555' },
                { ssl: true, number: '15555' }
              ]
            }
          ]
        },
        alternativeServers: [
          {
            country : 'usa',
            description: 'US',
            url: 'sha256-us.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80'],
            extraPorts: [
              {
                name: 'Low difficulty (10+)',
                showType: true,
                ports: [
                  { number: '5555' },
                  { ssl: true, number: '15555' }
                ]
              }
            ]
          },
          {
            country: 'canada',
            description: 'CANADA',
            url: 'sha256-ca.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80'],
            extraPorts: [
              {
                name: 'Low difficulty (10+)',
                showType: true,
                ports: [
                  { number: '5555' },
                  { ssl: true, number: '15555' }
                ]
              }
            ]
          },
          {
            country: 'england',
            description: 'EUROPE',
            url: 'sha256-eu.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80'],
            extraPorts: [
              {
                name: 'Low difficulty (10+)',
                showType: true,
                ports: [
                  { number: '5555' },
                  { ssl: true, number: '15555' }
                ]
              }
            ]
          },
          {
            country: 'singapore',
            description: 'ASIA',
            url: 'sha256-asia.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80'],
            extraPorts: [
              {
                name: 'Low difficulty (10+)',
                showType: true,
                ports: [
                  { number: '5555' },
                  { ssl: true, number: '15555' }
                ]
              }
            ]
          }
        ],
        showInWizard: false,
        guides: [
          {
            name: 'Antminer',
            url: 'https://unmineable.com/support/article/how-to-setup-antminer-for-asic-mining/',
            relativeUrl: '/support/article/how-to-setup-antminer-for-asic-mining/'
          },
          {
            name: 'Innosilicon',
            url: 'https://unmineable.com/support/article/how-to-setup-innosilicon-for-asic-mining/',
            relativeUrl: '/support/article/how-to-setup-innosilicon-for-asic-mining/'
          }
        ],
        xaxisCategoriesField: 'calculated',
        hasReportedHashrate: false,
        chartSeries: [
          { name: 'Speed', field: 'calculated' }
        ],
        chartOptions: {
          colors: ['#F7931B'],
          stroke: {
            show: true,
            curve: 'smooth',
            width: 3
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 90, 100],
              shade: 'light'
            },
            opacity: [1, 0]
          },
          dataLabels: {
            enabled: false
          },
          chart: {
            foreColor: '#373d3f',
            type: 'area',
            zoom: {
              enabled: true
            },
            toolbar: {
              tools: {
                download: false,
                reset: '<i class="fa fa-arrow-right"></i>'
              },
              autoSelected: 'pan'
            }
          },
          xaxis: {
            labels: {
              offsetY: -2,
              datetimeUTC: false
            },
            categories: [],
            type: 'datetime',
            min: 0
          },
          yaxis: {
            labels: {
              show: false
            }
          },
          legend: {
            offsetY: 10,
            itemMargin: {
              vertical: 5
            }
          },
          grid: {
            yaxis: {
              lines: {
                show: false
              }
            },
            xaxis: {
              lines: {
                show: false
              }
            }
          },
          tooltip: {
            x: {
              format: 'yyyy-MM-dd HH:mm'
            }
          }
        }
      },
      {
        code: 'scrypt',
        name: 'Scrypt',
        longName: 'Scrypt',
        typeCode: 'asic',
        type: 'ASIC',
        new: false,
        miningVia: 'ASICs',
        symbol: 'LTC',
        symbolLogo: 'https://unmineable.com/img/logos/LTC.png',
        symbolMerged: 'LTC + DOGE + BELLS',
        minimumVramRequirement: null,
        unitOfMeasurement: 'mh',
        preUnitOfMeasurement: 'm',
        minimumUnitOfMeasurement: 'h',
        minCalculatorUnit: 'm',
        maxCalculatorUnit: 't',
        wizardSort: 7,
        extraComment: 'Our Scrypt pools are LTC + DOGE + BELLS merged-mining based, rewarded assets are merged and converted automatically on each reward',
        globalServer: {
          description: 'Global',
          url: 'scrypt.unmineable.com',
          urlCopy: 'stratum+ssl://scrypt.unmineable.com',
          sslPorts: ['4444', '443'],
          defaultPort: '4444',
          alternativePorts: ['3333', '13333', '80']
        },
        alternativeServers: [
          {
            country : 'usa',
            description: 'US',
            url: 'scrypt-us.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'canada',
            description: 'CANADA',
            url: 'scrypt-ca.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'england',
            description: 'EUROPE',
            url: 'scrypt-eu.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'singapore',
            description: 'ASIA',
            url: 'scrypt-asia.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          }
        ],
        showInWizard: false,
        guides: [
          {
            name: 'Antminer',
            url: 'https://unmineable.com/support/article/how-to-setup-antminer-for-asic-mining/',
            relativeUrl: '/support/article/how-to-setup-antminer-for-asic-mining/'
          },
          {
            name: 'Innosilicon',
            url: 'https://unmineable.com/support/article/how-to-setup-innosilicon-for-asic-mining/',
            relativeUrl: '/support/article/how-to-setup-innosilicon-for-asic-mining/'
          }
        ],
        xaxisCategoriesField: 'calculated',
        hasReportedHashrate: false,
        chartSeries: [
          { name: 'Speed', field: 'calculated' }
        ],
        chartOptions: {
          colors: ['#355C9D'],
          stroke: {
            show: true,
            curve: 'smooth',
            width: 3
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 90, 100],
              shade: 'light'
            },
            opacity: [1, 0]
          },
          dataLabels: {
            enabled: false
          },
          chart: {
            foreColor: '#373d3f',
            type: 'area',
            zoom: {
              enabled: true
            },
            toolbar: {
              tools: {
                download: false,
                reset: '<i class="fa fa-arrow-right"></i>'
              },
              autoSelected: 'pan'
            }
          },
          xaxis: {
            labels: {
              offsetY: -2,
              datetimeUTC: false
            },
            categories: [],
            type: 'datetime',
            min: 0
          },
          yaxis: {
            labels: {
              show: false
            }
          },
          legend: {
            offsetY: 10,
            itemMargin: {
              vertical: 5
            }
          },
          grid: {
            yaxis: {
              lines: {
                show: false
              }
            },
            xaxis: {
              lines: {
                show: false
              }
            }
          },
          tooltip: {
            x: {
              format: 'yyyy-MM-dd HH:mm'
            }
          }
        }
      },
      {
        code: 'zelhash',
        name: 'ZelHash',
        longName: 'Equihash 125,4',
        typeCode: 'gpu',
        type: 'Graphic Card',
        new: false,
        miningVia: 'Graphic Cards',
        symbol: 'FLUX',
        symbolLogo: 'https://unmineable.com/img/logos/FLUX.png',
        symbolMerged: 'FLUX + parallel assets',
        minimumVramRequirement: '3GB',
        unitOfMeasurement: 'sol',
        preUnitOfMeasurement: '',
        minimumUnitOfMeasurement: 'sol',
        minCalculatorUnit: '',
        maxCalculatorUnit: 'm',
        wizardSort: 6,
        extraComment: 'Our ZelHash pools are FLUX based, rewarded parallel assets are converted and distributed on each reward',
        globalServer: {
          description: 'Global',
          url: 'zelhash.unmineable.com',
          urlCopy: 'stratum+ssl://zelhash.unmineable.com',
          sslPorts: ['4444', '443'],
          defaultPort: '4444',
          alternativePorts: ['3333', '13333', '80']
        },
        alternativeServers: [
          {
            country : 'usa',
            description: 'US',
            url: 'zelhash-us.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'canada',
            description: 'CANADA',
            url: 'zelhash-ca.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'england',
            description: 'EUROPE',
            url: 'zelhash-eu.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'singapore',
            description: 'ASIA',
            url: 'zelhash-asia.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          }
        ],
        showInWizard: true,
        guides: [
          {
            name: 'lolMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-lolminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-lolminer-for-gpu-mining/'
          },
          {
            name: 'GMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-gminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-gminer-for-gpu-mining/'
          },
          {
            name: 'miniZ',
            url: 'https://unmineable.com/support/article/how-to-setup-miniz-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-miniz-for-gpu-mining/'
          }
        ],
        isInOurEasyMiningApp: true,
        xaxisCategoriesField: 'calculated',
        hasReportedHashrate: false,
        chartSeries: [
          { name: 'Speed', field: 'calculated' }
        ],
        chartOptions: {
          colors: ['#2B61D1'],
          stroke: {
            show: true,
            curve: 'smooth',
            width: 3
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 90, 100],
              shade: 'light'
            },
            opacity: [1, 0]
          },
          dataLabels: {
            enabled: false
          },
          chart: {
            foreColor: '#373d3f',
            type: 'area',
            zoom: {
              enabled: true
            },
            toolbar: {
              tools: {
                download: false,
                reset: '<i class="fa fa-arrow-right"></i>'
              },
              autoSelected: 'pan'
            }
          },
          xaxis: {
            labels: {
              offsetY: -2,
              datetimeUTC: false
            },
            categories: [],
            type: 'datetime',
            min: 0
          },
          yaxis: {
            labels: {
              show: false
            }
          },
          legend: {
            offsetY: 10,
            itemMargin: {
              vertical: 5
            }
          },
          grid: {
            yaxis: {
              lines: {
                show: false
              }
            },
            xaxis: {
              lines: {
                show: false
              }
            }
          },
          tooltip: {
            x: {
              format: 'yyyy-MM-dd HH:mm'
            }
          }
        }
      },
      {
        code: 'beamhash',
        name: 'BeamHash',
        longName: 'BeamHashIII',
        typeCode: 'gpu',
        type: 'Graphic Card',
        new: false,
        miningVia: 'Graphic Cards',
        symbol: 'BEAM',
        symbolLogo: 'https://unmineable.com/img/logos/BEAM.png',
        minimumVramRequirement: '6GB',
        unitOfMeasurement: 'sol',
        preUnitOfMeasurement: '',
        minimumUnitOfMeasurement: 'sol',
        minCalculatorUnit: '',
        maxCalculatorUnit: 'm',
        wizardSort: 5,
        globalServer: {
          description: 'Global',
          url: 'beamhash.unmineable.com',
          urlCopy: 'stratum+ssl://beamhash.unmineable.com',
          sslPorts: ['4444', '443'],
          defaultPort: '4444',
          alternativePorts: ['3333', '13333', '80']
        },
        alternativeServers: [
          {
            country : 'usa',
            description: 'US',
            url: 'beamhash-us.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'canada',
            description: 'CANADA',
            url: 'beamhash-ca.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'england',
            description: 'EUROPE',
            url: 'beamhash-eu.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'singapore',
            description: 'ASIA',
            url: 'beamhash-asia.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          }
        ],
        showInWizard: true,
        guides: [
          {
            name: 'lolMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-lolminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-lolminer-for-gpu-mining/'
          },
          {
            name: 'NBMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-nbminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-nbminer-for-gpu-mining/'
          },
          {
            name: 'BMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-bminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-bminer-for-gpu-mining/'
          },
          {
            name: 'miniZ',
            url: 'https://unmineable.com/support/article/how-to-setup-miniz-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-miniz-for-gpu-mining/'
          }
        ],
        isInOurEasyMiningApp: true,
        xaxisCategoriesField: 'calculated',
        hasReportedHashrate: false,
        chartSeries: [
          { name: 'Speed', field: 'calculated' }
        ],
        chartOptions: {
          colors: ['#7DFAF5'],
          stroke: {
            show: true,
            curve: 'smooth',
            width: 3
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 90, 100],
              shade: 'light'
            },
            opacity: [1, 0]
          },
          dataLabels: {
            enabled: false
          },
          chart: {
            foreColor: '#373d3f',
            type: 'area',
            zoom: {
              enabled: true
            },
            toolbar: {
              tools: {
                download: false,
                reset: '<i class="fa fa-arrow-right"></i>'
              },
              autoSelected: 'pan'
            }
          },
          xaxis: {
            labels: {
              offsetY: -2,
              datetimeUTC: false
            },
            categories: [],
            type: 'datetime',
            min: 0
          },
          yaxis: {
            labels: {
              show: false
            }
          },
          legend: {
            offsetY: 10,
            itemMargin: {
              vertical: 5
            }
          },
          grid: {
            yaxis: {
              lines: {
                show: false
              }
            },
            xaxis: {
              lines: {
                show: false
              }
            }
          },
          tooltip: {
            x: {
              format: 'yyyy-MM-dd HH:mm'
            }
          }
        }
      },
      {
        code: 'autolykos',
        name: 'Autolykos',
        longName: 'Autolykos2',
        typeCode: 'gpu',
        type: 'Graphic Card',
        new: false,
        miningVia: 'Graphic Cards',
        symbol: 'ERG',
        symbolLogo: 'https://unmineable.com/img/logos/ERG.png',
        minimumVramRequirement: '4GB',
        unitOfMeasurement: 'mh',
        preUnitOfMeasurement: 'm',
        minimumUnitOfMeasurement: 'h',
        minCalculatorUnit: 'm',
        maxCalculatorUnit: 'g',
        wizardSort: 2,
        globalServer: {
          description: 'Global',
          url: 'autolykos.unmineable.com',
          urlCopy: 'stratum+ssl://autolykos.unmineable.com',
          sslPorts: ['4444', '443'],
          defaultPort: '4444',
          alternativePorts: ['3333', '13333', '80']
        },
        alternativeServers: [
          {
            country: 'usa',
            description: 'US',
            url: 'autolykos-us.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'canada',
            description: 'CANADA',
            url: 'autolykos-ca.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'england',
            description: 'EUROPE',
            url: 'autolykos-eu.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'singapore',
            description: 'ASIA',
            url: 'autolykos-asia.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          }
        ],
        showInWizard: true,
        guides: [
          {
            name: 'lolMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-lolminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-lolminer-for-gpu-mining/'
          },
          {
            name: 'NBMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-nbminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-nbminer-for-gpu-mining/'
          },
          {
            name: 'T-Rex',
            url: 'https://unmineable.com/support/article/how-to-setup-t-rex-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-t-rex-for-gpu-mining/'
          },
          {
            name: 'Nanominer',
            url: 'https://unmineable.com/support/article/how-to-setup-nanominer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-nanominer-for-gpu-mining/'
          },
          {
            name: 'TeamRedMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-teamredminer-for-gpu-mining',
            relativeUrl: '/support/article/how-to-setup-teamredminer-for-gpu-mining/'
          },
          {
            name: 'SRBMiner',
            url: 'https://www.unmineable.com/support/article/how-to-setup-srbminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-srbminer-for-gpu-mining/'
          }
        ],
        isInOurEasyMiningApp: true,
        xaxisCategoriesField: 'calculated',
        hasReportedHashrate: false,
        chartSeries: [
          { name: 'Speed', field: 'calculated' }
        ],
        chartOptions: {
          colors: ['#ff5e18'],
          stroke: {
            show: true,
            curve: 'smooth',
            width: 3
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 90, 100],
              shade: 'light'
            },
            opacity: [1, 0]
          },
          dataLabels: {
            enabled: false
          },
          chart: {
            foreColor: '#373d3f',
            type: 'area',
            zoom: {
              enabled: true
            },
            toolbar: {
              tools: {
                download: false,
                reset: '<i class="fa fa-arrow-right"></i>'
              },
              autoSelected: 'pan'
            }
          },
          xaxis: {
            labels: {
              offsetY: -2,
              datetimeUTC: false
            },
            categories: [],
            type: 'datetime',
            min: 0
          },
          yaxis: {
            labels: {
              show: false
            }
          },
          legend: {
            offsetY: 10,
            itemMargin: {
              vertical: 5
            }
          },
          grid: {
            yaxis: {
              lines: {
                show: false
              }
            },
            xaxis: {
              lines: {
                show: false
              }
            }
          },
          tooltip: {
            x: {
              format: 'yyyy-MM-dd HH:mm'
            }
          }
        }
      },
      {
        code: 'kawpow',
        name: 'Kawpow',
        typeCode: 'gpu',
        type: 'Graphic Card',
        miningVia: 'Graphic Cards',
        symbol: 'RVN',
        symbolLogo: 'https://unmineable.com/img/logos/RVN.png',
        minimumVramRequirement: '6GB',
        unitOfMeasurement: 'mh',
        preUnitOfMeasurement: 'm',
        minimumUnitOfMeasurement: 'h',
        minCalculatorUnit: 'm',
        maxCalculatorUnit: 'g',
        wizardSort: 1,
        globalServer: {
          description: 'Global',
          url: 'kp.unmineable.com',
          urlCopy: 'stratum+ssl://kp.unmineable.com',
          sslPorts: ['4444', '443'],
          defaultPort: '4444',
          alternativePorts: ['3333', '13333', '80']
        },
        alternativeServers: [
          {
            country: 'usa',
            description: 'US',
            url: 'kp-us.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'canada',
            description: 'CANADA',
            url: 'kp-ca.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'england',
            description: 'EUROPE',
            url: 'kp-eu.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'singapore',
            description: 'ASIA',
            url: 'kp-asia.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          }
        ],
        showInWizard: true,
        guides: [
          {
            name: 'NBMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-nbminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-nbminer-for-gpu-mining/'
          },
          {
            name: 'T-Rex',
            url: 'https://unmineable.com/support/article/how-to-setup-t-rex-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-t-rex-for-gpu-mining/'
          },
          {
            name: 'GMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-gminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-gminer-for-gpu-mining/'
          },
          {
            name: 'miniZ',
            url: 'https://unmineable.com/support/article/how-to-setup-miniz-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-miniz-for-gpu-mining/'
          },
          {
            name: 'TeamRedMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-teamredminer-for-gpu-mining',
            relativeUrl: '/support/article/how-to-setup-teamredminer-for-gpu-mining/'
          },
          {
            name: 'SRBMiner',
            url: 'https://www.unmineable.com/support/article/how-to-setup-srbminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-srbminer-for-gpu-mining/'
          },
          {
            name: 'BzMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-bzminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-bzminer-for-gpu-mining/'
          }
        ],
        isInOurEasyMiningApp: true,
        xaxisCategoriesField: 'calculated',
        hasReportedHashrate: false,
        chartSeries: [
          { name: 'Speed', field: 'calculated' }
        ],
        chartOptions: {
          colors: ['#FFEC60', '#FFF4AB'],
          stroke: {
            show: true,
            curve: 'smooth',
            width: [3, 2]
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 90, 100],
              shade: 'light'
            }
          },
          dataLabels: {
            enabled: false
          },
          chart: {
            foreColor: '#373d3f',
            type: 'area',
            zoom: {
              enabled: true
            },
            toolbar: {
              tools: {
                download: false,
                reset: '<i class="fa fa-arrow-right"></i>'
              },
              autoSelected: 'pan'
            }
          },
          xaxis: {
            labels: {
              offsetY: -2,
              datetimeUTC: false
            },
            categories: [],
            type: 'datetime',
            min: 0
          },
          yaxis: {
            labels: {
              show: false
            }
          },
          legend: {
            offsetY: -10
          },
          grid: {
            yaxis: {
              lines: {
                show: false
              }
            },
            xaxis: {
              lines: {
                show: false
              }
            }
          },
          tooltip: {
            x: {
              format: 'yyyy-MM-dd HH:mm'
            }
          }
        }
      },
      {
        code: 'etchash',
        name: 'Etchash',
        typeCode: 'gpu',
        type: 'Graphic Card',
        miningVia: 'Graphic Cards',
        symbol: 'ETC',
        symbolLogo: 'https://unmineable.com/img/logos/ETC.png',
        minimumVramRequirement: '4GB',
        unitOfMeasurement: 'mh',
        preUnitOfMeasurement: 'm',
        minimumUnitOfMeasurement: 'h',
        minCalculatorUnit: 'm',
        maxCalculatorUnit: 'g',
        wizardSort: 3,
        globalServer: {
          description: 'Global',
          url: 'etchash.unmineable.com',
          urlCopy: 'stratum+ssl://etchash.unmineable.com',
          sslPorts: ['4444', '443'],
          defaultPort: '4444',
          alternativePorts: ['3333', '13333', '80']
        },
        alternativeServers: [
          {
            country: 'usa',
            description: 'US',
            url: 'etchash-us.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'canada',
            description: 'CANADA',
            url: 'etchash-ca.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'england',
            description: 'EUROPE',
            url: 'etchash-eu.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'singapore',
            description: 'ASIA',
            url: 'etchash-asia.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          }
        ],
        showInWizard: true,
        guides: [
          {
            name: 'PhoenixMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-phoenixminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-phoenixminer-for-gpu-mining/'
          },
          {
            name: 'lolMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-lolminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-lolminer-for-gpu-mining/'
          },
          {
            name: 'NBMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-nbminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-nbminer-for-gpu-mining/'
          },
          {
            name: 'T-Rex',
            url: 'https://unmineable.com/support/article/how-to-setup-t-rex-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-t-rex-for-gpu-mining/'
          },
          {
            name: 'Nanominer',
            url: 'https://unmineable.com/support/article/how-to-setup-nanominer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-nanominer-for-gpu-mining/'
          },
          {
            name: 'GMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-gminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-gminer-for-gpu-mining/'
          },
          {
            name: 'miniZ',
            url: 'https://unmineable.com/support/article/how-to-setup-miniz-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-miniz-for-gpu-mining/'
          },
          {
            name: 'TeamRedMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-teamredminer-for-gpu-mining',
            relativeUrl: '/support/article/how-to-setup-teamredminer-for-gpu-mining/'
          }
        ],
        isInOurEasyMiningApp: true,
        xaxisCategoriesField: 'reported',
        hasReportedHashrate: false,
        chartSeries: [
          { name: 'Speed', field: 'calculated' }
        ],
        chartOptions: {
          colors: ['#209cee', '#1b85cc'],
          stroke: {
            show: true,
            curve: 'smooth',
            width: [3, 2],
            dashArray: [0, 3]
          },
          fill: {
            type: ['gradient', 'solid'],
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 90, 100],
              shade: 'light'
            },
            colors: ['#209cee', '#ffffff'],
            opacity: [1, 0]
          },
          dataLabels: {
            enabled: false
          },
          chart: {
            foreColor: '#373d3f',
            type: 'area',
            zoom: {
              enabled: true
            },
            toolbar: {
              tools: {
                download: false,
                reset: '<i class="fa fa-arrow-right"></i>'
              },
              autoSelected: 'pan'
            }
          },
          xaxis: {
            labels: {
              offsetY: -2,
              datetimeUTC: false
            },
            categories: [],
            type: 'datetime',
            min: 0
          },
          yaxis: {
            labels: {
              show: false
            }
          },
          legend: {
            offsetY: 10,
            itemMargin: {
              vertical: 5
            }
          },
          grid: {
            yaxis: {
              lines: {
                show: false
              }
            },
            xaxis: {
              lines: {
                show: false
              }
            }
          },
          tooltip: {
            x: {
              format: 'yyyy-MM-dd HH:mm'
            }
          }
        }
      },
      {
        code: 'ethash',
        name: 'Ethash',
        typeCode: 'gpu',
        type: 'Graphic Card',
        miningVia: 'Graphic Cards',
        symbol: 'ETHW',
        symbolLogo: 'https://unmineable.com/img/logos/ETHW.png',
        minimumVramRequirement: '6GB',
        unitOfMeasurement: 'mh',
        preUnitOfMeasurement: 'm',
        minimumUnitOfMeasurement: 'h',
        minCalculatorUnit: 'm',
        maxCalculatorUnit: 'g',
        wizardSort: 4,
        warningMessage: 'Please note that Ethash mining is now <strong>ETHW based</strong>, profitability is not the same as it was before The Merge. Also, because of the current ETHW high price volatility, expected daily rewards will vary.',
        globalServer: {
          description: 'Global',
          url: 'ethash.unmineable.com',
          urlCopy: 'stratum+ssl://ethash.unmineable.com',
          sslPorts: ['4444', '443'],
          defaultPort: '4444',
          alternativePorts: ['3333', '13333', '80']
        },
        alternativeServers: [
          {
            country: 'usa',
            description: 'US',
            url: 'ethash-us.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'canada',
            description: 'CANADA',
            url: 'ethash-ca.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'england',
            description: 'EUROPE',
            url: 'ethash-eu.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          },
          {
            country: 'singapore',
            description: 'ASIA',
            url: 'ethash-asia.unmineable.com',
            sslPorts: ['4444', '443'],
            defaultPort: '4444',
            alternativePorts: ['3333', '13333', '80']
          }
        ],
        showInWizard: true,
        guides: [
          {
            name: 'lolMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-lolminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-lolminer-for-gpu-mining/'
          },
          {
            name: 'NBMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-nbminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-nbminer-for-gpu-mining/'
          },
          {
            name: 'T-Rex',
            url: 'https://unmineable.com/support/article/how-to-setup-t-rex-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-t-rex-for-gpu-mining/'
          },
          {
            name: 'Nanominer',
            url: 'https://unmineable.com/support/article/how-to-setup-nanominer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-nanominer-for-gpu-mining/'
          },
          {
            name: 'GMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-gminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-gminer-for-gpu-mining/'
          },
          {
            name: 'BMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-bminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-bminer-for-gpu-mining/'
          },
          {
            name: 'miniZ',
            url: 'https://unmineable.com/support/article/how-to-setup-miniz-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-miniz-for-gpu-mining/'
          },
          {
            name: 'TeamRedMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-teamredminer-for-gpu-mining',
            relativeUrl: '/support/article/how-to-setup-teamredminer-for-gpu-mining/'
          },
          {
            name: 'SRBMiner',
            url: 'https://www.unmineable.com/support/article/how-to-setup-srbminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-srbminer-for-gpu-mining/'
          },
          {
            name: 'BzMiner',
            url: 'https://unmineable.com/support/article/how-to-setup-bzminer-for-gpu-mining/',
            relativeUrl: '/support/article/how-to-setup-bzminer-for-gpu-mining/'
          }
        ],
        isInOurEasyMiningApp: true,
        xaxisCategoriesField: 'reported',
        hasReportedHashrate: false,
        chartSeries: [
          { name: 'Speed', field: 'calculated' }
        ],
        chartOptions: {
          colors: ['#23D160', '#30bb61'],
          stroke: {
            show: true,
            curve: 'smooth',
            width: [3, 2],
            dashArray: [0, 3]
          },
          fill: {
            type: ['gradient', 'solid'],
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 90, 100],
              shade: 'light'
            },
            colors: ['#23D160', '#ffffff'],
            opacity: [1, 0]
          },
          dataLabels: {
            enabled: false
          },
          chart: {
            foreColor: '#373d3f',
            type: 'area',
            zoom: {
              enabled: true
            },
            toolbar: {
              tools: {
                download: false,
                reset: '<i class="fa fa-arrow-right"></i>'
              },
              autoSelected: 'pan'
            }
          },
          xaxis: {
            labels: {
              offsetY: -2,
              datetimeUTC: false
            },
            categories: [],
            type: 'datetime',
            min: 0
          },
          yaxis: {
            labels: {
              show: false
            }
          },
          legend: {
            offsetY: 10,
            itemMargin: {
              vertical: 5
            }
          },
          grid: {
            yaxis: {
              lines: {
                show: false
              }
            },
            xaxis: {
              lines: {
                show: false
              }
            }
          },
          tooltip: {
            x: {
              format: 'yyyy-MM-dd HH:mm'
            }
          }
        }
      }
    ]
  },
  getters: {
    algos         : (state) => state.algos
  }
}

export default vars




// WEBPACK FOOTER //
// ./src/store/vars.js